export const isSSR = () => typeof window === 'undefined';
//# sourceMappingURL=isSSR.js.map